import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FilterSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FilterSVG;
